"use client";

import { cn } from "@/lib/utils";
import { FloatingTooltip } from "./floating-tooltip";
import { TooltipContent, type TooltipRow } from "./tooltip-content";

export interface NodeTooltipProps {
  visible: boolean;
  anchor: HTMLElement | SVGElement | { x: number; y: number } | null;
  title?: string;
  rows?: TooltipRow[];
  content?: React.ReactNode;
  /** Identity of the rendered content — set it to animate the swap between two anchors. */
  contentKey?: string;
  offsetY?: number;
  className?: string;
  panelStyle?: React.CSSProperties;
}

export function NodeTooltip({
  visible,
  anchor,
  title,
  rows,
  content,
  contentKey,
  offsetY = 12,
  className,
  panelStyle,
}: NodeTooltipProps) {
  return (
    <FloatingTooltip
      anchor={{ mode: "viewport", offset: offsetY, target: anchor }}
      contentKey={contentKey}
      panelClassName={cn(
        "overflow-hidden rounded-md border border-[var(--chart-tooltip-border)] bg-chart-tooltip-background shadow-md",
        className
      )}
      panelStyle={panelStyle}
      style={{ zIndex: 60 }}
      visible={visible}
    >
      {content ?? <TooltipContent rows={rows ?? []} title={title} />}
    </FloatingTooltip>
  );
}

NodeTooltip.displayName = "NodeTooltip";
